// Dev-validation toggle, injected by the app (e.g. web: setAnalyticsDebug(import.meta.env.DEV)).
// Kept here so `common/analytics` never reads bundler-specific globals (process.env / import.meta)
// — which keeps it safe for React Native.
let debug = false;

export function setAnalyticsDebug(on: boolean): void {
  debug = on;
}

export function isAnalyticsDebug(): boolean {
  return debug;
}
